<template>
  <div>
    <div id="user-infos">
      <!-- 头部 -->
      <div class="section-title-box">
        <div class="title-text">客户信息</div>
        <!--status 0：正常，1：停用，2：注销 -->
        <div class="user-baned" v-if="[1, 2].includes(userInfo.status)">
          <img src="../../../../assets/imgs/work-wx/customer/ban.png" />
          <span class="ban-text">{{
            userInfo.status === 1 ? '账号已停用' : '账号已注销'
          }}</span>
        </div>
        <div class="bind-btn" @click="goBindAccount">更换绑定账号</div>
        <div class="fill-space"></div>
        <div class="behavior-btn" @click="goBehaviorList">查看客户行为</div>
      </div>

      <!-- 基本信息 -->
      <div class="section-content-container">
        <div class="section-content-desc">
          <div class="section-item col-2">
            <div class="item-label">昵称：</div>
            <div class="item-content">
              <div class="name-content">
                <span
                  class="name"
                  :class="{ 'has-amount': userInfo.sum_gmv }"
                  >{{ userInfo.nickname }}</span
                >
                <span class="history-amount" v-if="userInfo.sum_gmv"
                  >累计￥{{ userInfo.sum_gmv / 100 }}</span
                >
              </div>
            </div>
          </div>
          <div class="section-item col-2" v-if="userInfo.distributor_name">
            <div class="item-label">来源：</div>
            <div class="item-content">
              <div class="source-content">
                <div
                  class="source-name"
                  :class="{ 'has-amount': userInfo.is_key_customer }"
                >
                  {{ userInfo.distributor_name }}
                </div>
                <span class="tag import-tag" v-if="userInfo.is_key_customer"
                  >重要</span
                >
              </div>
            </div>
          </div>
          <div class="section-item">
            <div class="item-label">签专：</div>
            <div class="item-content">
              {{ userInfo.cs_name }}
            </div>
          </div>
          <div class="section-item col-2">
            <div class="item-label">手机号：</div>
            <div class="item-content">{{ userInfo.mobile_phone }}</div>
          </div>
          <div class="section-item col-2">
            <div class="item-label">用户ID：</div>
            <div class="item-content">{{ userInfo.user_account_id }}</div>
          </div>
        </div>

        <div class="section-pay-time" v-if="userInfo.last_pay_time">
          <img
            class="icon-pay"
            src="../../../../assets/imgs/work-wx/customer/icon-time.png"
            alt=""
          />
          <div class="section-pay-time-text">
            客户最后一次支付订单时间：{{ userInfo.last_pay_time }}
          </div>
        </div>

        <div class="section-pay-time" v-if="userInfo.create_time">
          <img
            class="icon-pay"
            src="../../../../assets/imgs/work-wx/customer/icon-time.png"
            alt=""
          />
          <div class="section-pay-time-text">
            客户注册时间：{{ userInfo.create_time }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    goBindAccount() {
      this.$router.push({
        name: 'bindCustomerAccount',
      });
    },
    goBehaviorList() {
      this.$router.push({
        name: 'WorkWXCustomerBehaviorList',
        query: { id: this.userInfo.user_account_id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
#user-infos {
  width: 100%;
  display: flex;
  background-color: white;
  flex-direction: column;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  .section-title-box {
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
    border-bottom: 2px solid #dee3f0;
    .title-text {
      font-size: 14px;
      color: #2c3344;
      font-weight: bold;
    }
    .user-baned {
      display: flex;
      align-items: center;
      margin-left: 12px;
      img {
        width: 14px;
        height: 14px;
      }
      .ban-text {
        font-size: 14px;
        color: rgba(242, 80, 96, 1);
        margin-left: 4px;
      }
    }
    .bind-btn {
      font-size: 12px;
      color: #00a2fc;
      line-height: 12px;
      margin-left: 8px;
      cursor: pointer;
    }
    .fill-space {
      flex: 1;
    }
    .behavior-btn {
      padding: 0 8px;
      height: 28px;
      background-color: #3fa2f5;
      border-radius: 2px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .section-content-container {
    padding-bottom: 12px;
    .section-content-desc {
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      .section-item {
        display: flex;
        margin-top: 13px;
        width: 100%;
        .name-content,
        .source-content {
          width: 100%;
          display: flex;
          align-items: center;
          .name,
          .source-name {
            flex: 1;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            word-break: break-all;
          }
          .name {
            max-width: 300px;
            &.has-amount {
              max-width: 220px;
            }
          }
          .source-name {
            max-width: 120px;
            &.has-amount {
              max-width: 94px;
            }
          }
          .history-amount {
            flex-shrink: 0;
            margin-left: 10px;
            padding: 0 4px;
            border: 1px solid #16dce5;
            color: #16dce5;
            background-color: rgba(141, 232, 236, 0.1);
            margin-left: 10px;
            display: inline-block;
            border-radius: 2px;
          }
        }
        &.col-2 {
          width: 50%;
          .name {
            max-width: 140px;
            &.has-amount {
              max-width: 80px;
            }
          }
        }
        .item-label {
          flex-shrink: 0;
          display: flex;
          align-items: flex-start;
          padding-left: 16px;
          color: #717785;
          font-size: 12px;
          line-height: 20px;
        }
        .item-content {
          flex: 1;
          display: flex;
          align-items: start;
          flex-wrap: wrap;
          color: #222222;
          font-size: 12px;
          line-height: 20px;
          padding-right: 16px;
          font-weight: 400;
          .tag {
            font-size: 12px;
            line-height: 16px;
            padding: 0 6px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            margin-left: 4px;
            &.import-tag {
              color: #fb8339;
              background: #fff8f0;
              border-color: #ffd9b5;
            }
          }
        }
      }
    }

    .section-pay-time {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 12px;
      border-radius: 20px;
      margin: 10px 16px 0;
      height: 32px;
      background: #f2f3f5;
      border-radius: 4px;
      .icon-pay {
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 8px;
      }
      .section-pay-time-text {
        font-size: 12px;
      }
    }
  }
}
</style>
